import { ReactComponent as CrossIcon } from "../../assests/close-x.svg";
import { ReactComponent as VcutIcon } from "../../assests/v-cut-icon.svg";
import { ReactComponent as SendIcon } from "../../assests/images/send-icon-black.svg";
import chatBotGif from "../../assests/chatBotGif.gif";
import { ReactComponent as AddyIcon } from "../../assests/addy-icon.svg";
import UserIcon from "../../assests/user-icon.svg";
import {
  Input,
  Image,
  Divider,
  FloatButton,
  Typography,
  Row,
  Col,
  Card,
  Modal,
  Button,
} from "../../components/common/utils/antd-imports/AntdImports";
import "./chatbot.css";
import React, { useCallback, useEffect, useRef, useState } from "react";
import IconStack from "../../components/common/reusable-svg-icons/icon-stack";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchChatBotResponse,
  getChatBotNewSchema,
} from "../../store/thunks/common-thunks/commonThunk";
import { useLocation, useNavigate } from "react-router-dom";
import { formatToUSCurrency } from "../../components/common/utils/Utils";
import CollapseWhite from "../../components/common/reusable-svg-icons/collapse-white-icon";
import { useMediaQuery } from "react-responsive";
import RFPModal from "../../components/modal/rfp-request-modal/RfpRequestModal";
import {
  addBreadcrumb,
  resetBreadcrumbs,
  setBreadcrumbs,
} from "../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { ReloadOutlined } from "@ant-design/icons";
import { ReactComponent as reload } from "../../assests/chat-refresh-icon.svg";
import { ReactComponent as RedirectIcon } from "../../assests/Frame.svg";
const Text = Typography;
export const Chatbot = ({ forceOpen, form }) => {
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const { isLoading, response } = useSelector((state) => state.chatBot);
  const { chatResponse, isChatLoading, error } = useSelector(
    (state) => state.newChatSchema,
  );
  const isMobile = useMediaQuery({ maxWidth: 425 });
  const messagesEndRef = useRef(null);
  const [showUserHelpText, setShowUserHelpText] = useState(true);
  const [chatView, setChatView] = useState("float");
  const [messages, setMessages] = useState([]);
  const [userQuery, setUserQuery] = useState("");
  const userDetails = JSON.parse(localStorage.getItem("user"));
  const sessionId = sessionStorage.getItem("sessionId");
  const [uniqueId, setUniqueId] = useState(sessionId);
  const PENDING_CHAT_ACTION = "pendingChatAction";
  const DISABLED_LOAD_MORE_BUTTONS = "disabledLoadMoreButtons";
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const userRole = useSelector((state) => state.login.userType);
  const [RFP, setRFP] = useState(false);
  const [selectedTransferProducts, setSelectedTransferProducts] = useState([]);
  const autoTimerRef = useRef(null);
  const allowedChatbotParams = {
    "what-is-good-cpm": "What is a good CPM?",
  };

  useEffect(() => {
    if (location.pathname === "/login") {
      setChatView("float");
    }
  }, [location.pathname]);
  const LoadMoreButton = ({ buttonId, onLoadMore }) => {
    const getDisabledButtons = () => {
      try {
        return JSON.parse(
          sessionStorage.getItem(DISABLED_LOAD_MORE_BUTTONS) || "[]",
        );
      } catch {
        return [];
      }
    };
    const [clicked, setClicked] = useState(() =>
      getDisabledButtons().includes(buttonId),
    );
    const handleClick = () => {
      setClicked(true);
      const disabledButtons = getDisabledButtons();
      if (!disabledButtons.includes(buttonId)) {
        sessionStorage.setItem(
          DISABLED_LOAD_MORE_BUTTONS,
          JSON.stringify([...disabledButtons, buttonId]),
        );
      }
      if (!isLoggedIn) {
        sessionStorage.setItem("pendingChatAction", "loadMoreProducts");
        sessionStorage.setItem("openChatbot", "true");
        navigate("/login");
        return;
      }
      onLoadMore();
    };
    return (
      <Button
        type="primary"
        className={`billboard-button-2 browse-all-products-chat ${clicked ? "disabled-opacity" : ""}`}
        icon={<ReloadOutlined />}
        disabled={clicked}
        onClick={handleClick}
      >
        <Text className="load-more-text-chat">Show more products</Text>
      </Button>
    );
  };
  useEffect(() => {
    if (localStorage.getItem("chatAutoShown") === "true") return;
    autoTimerRef.current = setTimeout(() => {
      setChatView((prev) => {
        if (prev === "float") {
          localStorage.setItem("chatAutoShown", "true");
          return "initial";
        }
        return prev;
      });
    }, 10000);

    return () => {
      if (autoTimerRef.current) {
        clearTimeout(autoTimerRef.current);
      }
    };
  }, []);

  // Auto triggering the chatbot depends on the url
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const chatParam = params.get("chatParam");
    if (!chatParam) return;
    const cleanedQuery = chatParam
      ?.replace(/[-_/]+/g, " ")
      ?.replace(/[^a-zA-Z\s?]/g, " ")
      ?.replace(/\s+/g, " ")
      ?.trim();

    if (!cleanedQuery) return;
    setChatView("interaction");
    sendQuestionToAI(cleanedQuery);
  }, [location.search]);

  useEffect(() => {
    if (!isLoggedIn) return;
    const pendingChatAction = sessionStorage.getItem("pendingChatAction");
    const shouldOpenChatbot = sessionStorage.getItem("openChatbot");
    if (
      pendingChatAction === "loadMoreProducts" &&
      shouldOpenChatbot === "true"
    ) {
      setChatView("interaction");
      sessionStorage.removeItem("pendingChatAction");
      sessionStorage.removeItem("openChatbot");
      sendQuestionToAI("Show more products");
      return;
    }
    const shouldRefresh = sessionStorage.getItem("chatRefreshAfterLogin");
    if (shouldRefresh === "true") {
      dispatch(
        getChatBotNewSchema({
          user_input:
            userRole === "owner" ? "Sell Advertising" : "Purchase Advertising",
        }),
      );
      sessionStorage.removeItem("chatRefreshAfterLogin");
    }
    const pendingPath = localStorage.getItem("pendingBreadcrumbPath");
    if (pendingPath) {
      setDynamicBreadcrumb(pendingPath);
      localStorage.removeItem("pendingBreadcrumbPath");
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (!chatResponse?.chat_response?.response) return;
    const botResponse = chatResponse?.chat_response?.response;
    pushBotMessage({
      text: botResponse.response,
      suggestions: botResponse?.suggestions || [],
      redirectUrl: botResponse?.redirect || null,
      hint: botResponse?.hint || null,
    });
    if (botResponse?.action === "open_rfp_modal") {
      setRFP(true);
    }
  }, [chatResponse]);

  useEffect(() => {
    if (!response) return;
    // If API already returns string
    if (typeof response === "string") {
      pushBotMessage({ text: response });
      return;
    }
    // If API returns object
    pushBotMessage({
      text: response?.response || response?.message,
      suggestions: response?.suggestions || [],
      redirectUrl: response?.redirect_url || null,
      openRfpModal: response?.action || null,
    });
  }, [response]);

  // auto scroll
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [messages, isChatLoading]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(
        getChatBotNewSchema({
          user_input: "Buyer/Seller",
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (
      userDetails?.message.toLowerCase() == "login successful" ||
      !userDetails?.message
    ) {
      let chatbotId = sessionStorage.getItem("sessionId");
      setUniqueId(chatbotId);
    }
  }, [userDetails?.message]);

  useEffect(() => {
    let chatbotId = sessionStorage.getItem("sessionId");
    setUniqueId(chatbotId);
  }, [sessionId]);
  useEffect(() => {
    if (forceOpen) {
      setChatView("interaction");
      // Keep this dispatch
      // dispatch(
      //   getChatBotNewSchema({
      //     user_input: "Buyer/Seller",
      //   }),
      // );
    }
  }, [forceOpen]);
  const handleProductDetails = (product) => {
    if (isLoggedIn) {
      navigate(`/buyer/productsdetails?_id=${btoa(product?.product_id)}`, {
        state: {
          productId: product?.product_id,
        },
      });
      dispatch(
        addBreadcrumb({
          title: product?.title,
          path: `/buyer/productsdetails?_id=${btoa(product?.product_id)}`,
        }),
      );
    } else {
      navigate(`/productsdetails?_id=${btoa(product?.product_id)}`, {
        state: {
          productId: product?.product_id,
        },
      });
      dispatch(
        addBreadcrumb({
          title: product?.title,
          path: `/productsdetails?_id=${btoa(product?.product_id)}`,
        }),
      );
    }
  };
  // for the getting the products data
  useEffect(() => {
    if (!response) return;
    const apiResponse = response?.response;
    const suggestions = response?.suggestions || [];
    // products is a string
    if (typeof apiResponse?.products === "string") {
      const messageId = `${Date.now()}-${Math.random()}`;
      pushBotMessage({
        id: messageId,
        text: (
          <div>
            <div className="no-products-message">
              <Text className="chat-reponce-text-bot">
                {apiResponse?.products}
              </Text>
            </div>

            {/* Suggestions */}
            {suggestions.length > 0 && (
              <div className="chat-suggestions">
                {suggestions?.map((item, idx) => (
                  <div
                    key={idx}
                    className="user-options"
                    onClick={() => handleFetchInfo(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        ),
      });
      return;
    }
    // products is an array
    const rawProducts = Array.isArray(apiResponse?.products)
      ? apiResponse?.products
      : [];
    const products = rawProducts.filter(
      (item) => item && typeof item === "object",
    );
    const productMessage = rawProducts?.find(
      (item) => typeof item === "string",
    );
    const hasMore = apiResponse?.has_more === true;
    const messageId = `${Date?.now()}-${Math?.random()}`;
    // Products available
    const topProducts = products?.slice(0, 3);
    pushBotMessage({
      id: messageId,
      text: (
        <div>
          {topProducts?.map((product, index) => (
            <Card
              key={product?.product_id || index}
              style={{ marginBottom: "1rem", cursor: "pointer" }}
              onClick={
                userRole !== "owner"
                  ? () => handleProductDetails(product)
                  : undefined
              }
            >
              <Row gutter={[10, 10]}>
                <Col span={12} className="product-id">
                  {product?.site_no}
                </Col>
                <Col span={12}>
                  <strong
                    style={{
                      textDecoration:
                        userRole !== "owner" ? "underline" : "none",
                      cursor: userRole !== "owner" ? "pointer" : "default",
                    }}
                    onClick={
                      userRole !== "owner"
                        ? () => handleProductDetails(product)
                        : undefined
                    }
                  >
                    {product?.title}
                  </strong>
                </Col>
                <Col span={12}>{product?.state}</Col>
                <Col span={12}>
                  Price:{" "}
                  {product?.default_price
                    ? formatToUSCurrency(product?.default_price)
                    : "N/A"}
                </Col>
              </Row>
            </Card>
          ))}

          {!hasMore && productMessage && (
            <div style={{ marginBottom: "12px" }}>
              <Text className="chat-suggestions">{productMessage}</Text>
            </div>
          )}

          <Row
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {hasMore && userRole !== "owner" && (
              <LoadMoreButton
                buttonId={messageId}
                onLoadMore={() => {
                  sendQuestionToAI("Show more products");
                }}
              />
            )}
            {hasMore && userRole !== "owner" && (
              <Button
                icon={<RedirectIcon style={{ width: "18px" }} />}
                className="browse-all-products-chat button-browse-color-chat-bot"
                onClick={() => {
                  const path = !userDetails
                    ? "/products"
                    : userDetails?.user?.user_type !== "owner"
                      ? "/buyer/products"
                      : null;

                  if (path) {
                    navigate(path);
                  }
                }}
              >
                <Text className="addy-may-occasional-text">
                  Browse all products
                </Text>
              </Button>
            )}
          </Row>
        </div>
      ),
    });
  }, [response]);
  const setDynamicBreadcrumb = (targetPath) => {
    const rolePrefix = userRole === "owner" ? "/seller" : "/buyer";
    // DASHBOARD
    if (targetPath.includes("/dashboard")) {
      dispatch(
        setBreadcrumbs([
          {
            title: "Dashboard",
            path: `${rolePrefix}/dashboard`,
          },
        ]),
      );
    }
    // PRODUCTS
    else if (targetPath.includes("/products")) {
      if (isLoggedIn) {
        dispatch(
          setBreadcrumbs([
            {
              title: "Dashboard",
              path: `${rolePrefix}/dashboard`,
            },
            {
              title: "Shop",
              path: `${rolePrefix}/products`,
            },
          ]),
        );
      } else {
        dispatch(
          setBreadcrumbs([
            {
              title: "Home",
              path: "/",
            },
            {
              title: "Shop",
              path: "/products",
            },
          ]),
        );
      }
    } else if (
      targetPath.includes("/viewCampaigns") &&
      targetPath.includes("segment=insertion_order")
    ) {
      dispatch(
        setBreadcrumbs(
          userRole !== "basic"
            ? [
                {
                  title: "Dashboard",
                  path: "/seller/dashboard",
                },
                {
                  title: "Campaigns",
                  path: "/seller/viewCampaigns?segment=insertion_order",
                },
                {
                  title: "Insertion Order",
                  path: "/seller/viewCampaigns?segment=insertion_order",
                },
              ]
            : [
                {
                  title: "Dashboard",
                  path: "/buyer/dashboard",
                },
                {
                  title: "Shop",
                  path: "/buyer/products",
                },
              ],
        ),
      );
    } else if (
      targetPath.includes("/mycampaigns") &&
      targetPath.includes("segment=saved_campaign")
    ) {
      dispatch(
        setBreadcrumbs(
          userRole !== "owner"
            ? [
                {
                  title: "Dashboard",
                  path: "/buyer/dashboard",
                },
                {
                  title: "Campaigns",
                  path: "/buyer/mycampaigns?segment=saved_campaign",
                },
                {
                  title: "Saved Campaigns",
                  path: "/buyer/mycampaigns?segment=saved_campaign",
                },
              ]
            : [
                {
                  title: "Dashboard",
                  path: "/seller/dashboard",
                },
              ],
        ),
      );
    }
    // CONTACT
    else if (targetPath.includes("/contact")) {
      dispatch(
        resetBreadcrumbs({
          title: "Contact",
          path: `${rolePrefix}/contact`,
        }),
      );
    } else if (targetPath.includes("/rfpRequests")) {
      if (userRole == "owner") {
        dispatch(
          setBreadcrumbs([
            {
              title: "Dashboard",
              path: `${rolePrefix}/dashboard`,
            },
            {
              title: "RFP Requests",
              path: `${rolePrefix}/rfpRequests`,
            },
          ]),
        );
      } else if (userRole == "basic") {
        dispatch(
          setBreadcrumbs([
            {
              title: "Dashboard",
              path: `${rolePrefix}/dashboard`,
            },
            {
              title: "Shop",
              path: `${rolePrefix}/products`,
            },
          ]),
        );
      }
    } else if (targetPath.includes("/myproducts")) {
      if (userRole == "owner") {
        dispatch(
          setBreadcrumbs([
            {
              title: "Dashboard",
              path: `${rolePrefix}/dashboard`,
            },
            {
              title: "My Products",
              path: `${rolePrefix}/myproducts`,
            },
          ]),
        );
      } else if (userRole == "basic") {
        dispatch(
          setBreadcrumbs([
            {
              title: "Dashboard",
              path: `${rolePrefix}/dashboard`,
            },
            {
              title: "Shop",
              path: `${rolePrefix}/products`,
            },
          ]),
        );
      }
    }
  };

  // converting the all responces into single array
  const pushBotMessage = ({ text, redirectUrl, ...rest }) => {
    if (typeof text === "object" && !React.isValidElement(text)) {
      console.error("Invalid bot message:", text);
      return;
    }
    setMessages((prev) => [...prev, { role: "bot", text, ...rest }]);
    if (!redirectUrl) return;
    const isSubmitRFP = text?.toLowerCase()?.includes("submit an rfp");
    if (isSubmitRFP) return;

    setTimeout(() => {
      try {
        const finalUrl = getRedirectUrl(redirectUrl);
        // Clean DB slashes like http:\/\/
        const cleanedFinalUrl = finalUrl.replace(/\\\//g, "/");
        const parsedUrl = new URL(cleanedFinalUrl, window.location.origin);
        const path = parsedUrl.pathname + parsedUrl.search;
        if (cleanedFinalUrl.includes("outlook.office.com")) {
          window.open(cleanedFinalUrl, "_blank", "noopener,noreferrer");
          return;
        }
        if (
          parsedUrl.pathname === "/login" &&
          parsedUrl.search.includes("redirect=")
        ) {
          const redirectTarget = new URLSearchParams(parsedUrl.search).get(
            "redirect",
          );

          if (redirectTarget) {
            sessionStorage.setItem("chatPostLogin", redirectTarget);
            localStorage.setItem("pendingBreadcrumbPath", redirectTarget);
            sessionStorage.setItem("openChatbot", "true");
            // Set breadcrumb based on redirect target
            setDynamicBreadcrumb(redirectTarget);
          }
          navigate("/login");
          return;
        }
        setDynamicBreadcrumb(path);
        let finalPath = path;

        // Only modify for buyer products page
        if (!isLoggedIn && path.startsWith("/buyer/products")) {
          finalPath = path.replace("/buyer", "");
        }

        navigate(finalPath);
      } catch (error) {
        console.error("Redirect handling error:", error);
      }
    }, 1000);
  };

  const handleChatIcon = () => {
    if (autoTimerRef.current) {
      clearTimeout(autoTimerRef.current);
    }
    setChatView("float");
  };
  const handleOpenInteraction = () => {
    if (autoTimerRef.current) {
      clearTimeout(autoTimerRef.current);
    }
    localStorage.setItem("chatAutoShown", "true");
    setChatView("interaction");
  };

  const handleCloseChat = () => {
    if (autoTimerRef.current) {
      clearTimeout(autoTimerRef.current);
    }
    localStorage.setItem("chatAutoShown", "true");
    setChatView("float");
  };
  const handleFetchInfo = useCallback(
    (info) => {
      // Add user message instantly for better UX
      setMessages((prevMessages) => [
        ...prevMessages,
        { role: "user", text: info },
      ]);
      dispatch(
        getChatBotNewSchema({
          user_input: info,
        }),
      );
    },
    [dispatch],
  );

  const getRedirectUrl = (url) => {
    const EB_DOMAIN =
      "http://amp-test3-env.eba-m3ngsnpf.us-east-1.elasticbeanstalk.com";

    const isLocal =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    if (isLocal && url?.startsWith(EB_DOMAIN)) {
      return url.replace(EB_DOMAIN, window.location.origin);
    }

    return url;
  };

  // handling the user query
  const sendQuestionToAI = (question) => {
    const finalQuery = question || userQuery;
    if (!finalQuery.trim()) return;
    setMessages((prev) => [
      ...prev,
      {
        role: "user",
        text: finalQuery,
      },
    ]);
    const payload = {
      session_id: uniqueId,
      user_input: finalQuery,
      user_id: userDetails?.user ? userDetails?.user?.id?.toString() : "",
    };
    dispatch(fetchChatBotResponse(payload));
    setUserQuery("");
  };
  // handling the raw json data
  const renderBotText = (text) => {
    if (typeof text !== "string") return text;
    const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/;
    const match = text.match(markdownLinkRegex);
    if (!match) {
      return text; // normal text
    }
    const [, label, url] = match;

    return (
      <>
        {text.replace(markdownLinkRegex, "").trim()}{" "}
        <span
          className="chatbot-navigation-link"
          onClick={() => {
            const finalUrl = getRedirectUrl(url);
            const parsedUrl = new URL(finalUrl);
            if (parsedUrl.pathname.endsWith("/login")) {
              sessionStorage.setItem("openChatbot", "true");
            }
            const path = new URL(finalUrl).pathname + new URL(finalUrl).search;
            navigate(path);
          }}
        >
          {label}
        </span>
      </>
    );
  };

  // redirecting to the respective pages
  const handleRedirectToPages = (msg) => {
    if (!msg?.redirectUrl) return;
    const url = getRedirectUrl(msg?.redirectUrl);
    const path = new URL(url).pathname + new URL(url).search;
    navigate(path);
  };
  //intial chat bot options
  const userOptionsList = [
    { id: 1, label: "Purchase Advertising", value: "Purchase Advertising" },
    { id: 2, label: "Sell Advertising", value: "Sell Advertising" },
    { id: 3, label: "Just Look Around", value: "Just Look Around" },
    { id: 4, label: "I Need Help", value: "I Need Help" },
  ];
  const loggedInRoleAccess = {
    basic: [1, 3, 4],
    owner: [2, 3, 4],
  };
  const getFilteredOptions = ({ isLoggedIn, role }) => {
    // If NOT logged in → Show ALL
    if (!isLoggedIn) return userOptionsList;
    // If logged in → check role mapping
    const allowedIds = loggedInRoleAccess[role];
    if (!allowedIds) return userOptionsList;
    return userOptionsList.filter((opt) => allowedIds.includes(opt.id));
  };

  const filteredOptions = getFilteredOptions({
    isLoggedIn,
    role: userRole,
  });
  const handleCancel = () => {
    form.resetFields();
    setSelectedTransferProducts([]);
    setRFP(false);
  };
  return (
    <>
      {chatView === "float" && (
        <FloatButton
          shape="circle"
          style={{ insetInlineEnd: 10 }}
          icon={<AddyIcon />}
          className="float-chat-enquiry-btn-home back-ground-color"
          onClick={handleOpenInteraction}
        />
      )}
      <>
        <div className="chatbot-float-wrapper">
          {/* Chatbot on first/page Load */}
          {chatView === "initial" && (
            <div className="chatbot-initial-section">
              <div className="greet-element">
                <div className="greet-text">Hello! I'm Addy</div>
                <CrossIcon
                  className="chat-close-icon"
                  defaultColor="#000"
                  onClick={handleCloseChat}
                />
              </div>

              <div className="user-interaction-element">
                <VcutIcon className="v-cut-icon" />
                <div className="chatbot-gif">
                  <img className="gif-icon" src={chatBotGif} alt="Chat Bot" />
                </div>
                <div className="chatbot-help-text">
                  {isMobile
                    ? "Estimate campaign costs instantly."
                    : "I can help you estimate campaign costs based on your selected locations and dates. Get quick insights before you move forward."}
                </div>
                <Input
                  onClick={handleOpenInteraction}
                  className="chatbot-input"
                  placeholder="Ask Addy.."
                  suffix={
                    <span>
                      <SendIcon className={`chatSendIcon`} />
                    </span>
                  }
                />
              </div>
            </div>
          )}

          {/* Chat window for user questionnaire/ */}
          {chatView === "interaction" && (
            <div
              className={`user-interaction-section ${!showUserHelpText ? "with-help-text" : ""}`}
            >
              <div className="chat-window">
                <div
                  className="chat-header"
                  onClick={() => {
                    setChatView("float");
                  }}
                >
                  <div className="addy-greet">
                    <AddyIcon /> <span>Hi, I'm Addy</span>
                  </div>
                  <div className="collapse-icon-wrapper">
                    <CollapseWhite />
                  </div>
                </div>
                <div className="chat-body">
                  <div className="chat-message-wrapper">
                    <div className="message-content-wrapper">
                      <div className="message-text">
                        Hello, I'm Addy!!! How can I help you ?
                      </div>
                      <div className="role-selection">
                        <Row className="please-select-row">
                          <IconStack size={30} />
                          <div className="chat-reponce-text-bot">
                            How would you like to get started?
                          </div>
                        </Row>
                        <div className="user-options-wrapper">
                          {filteredOptions?.map((option) => (
                            <div
                              key={option.id}
                              className="user-options"
                              onClick={() => handleFetchInfo(option.value)}
                            >
                              {option.label}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="chat-messages">
                    {messages?.map((msg, index) => (
                      <div
                        key={index}
                        ref={
                          index === messages.length - 1 ? messagesEndRef : null
                        }
                        className={`chat-bubble ${msg?.role}`}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "7px",
                            justifyContent:
                              msg?.role === "user" ? "flex-end" : "flex-start",
                          }}
                        >
                          <Row
                            className={` ${
                              msg?.role === "bot"
                                ? "reponce-box-container-bot"
                                : "reponce-box-container"
                            }`}
                          >
                            <Col
                              className={`${
                                msg?.role === "bot" ? "bot-width" : ""
                              }`}
                            >
                              {" "}
                              {msg?.role === "bot" && (
                                <IconStack
                                  size={30}
                                  style={{ marginTop: "3px" }}
                                />
                              )}
                            </Col>
                            <Col
                              className={`${
                                msg?.role === "bot" ? "separate-col" : ""
                              }`}
                            >
                              <Text
                                className={`${
                                  msg?.role === "bot"
                                    ? "chat-reponce-text-bot"
                                    : "chat-reponce-text"
                                }`}
                              >
                                {msg?.role === "bot"
                                  ? renderBotText(msg.text)
                                  : msg.text}
                              </Text>
                            </Col>
                          </Row>

                          {msg?.role === "user" && (
                            <div className="chat-user-icon-background">
                              <Image src={UserIcon} preview={false} />
                            </div>
                          )}
                        </div>
                        {msg?.role === "bot" && msg?.redirectUrl && (
                          <div
                            className="chat-redirect-link-div"
                            onClick={() => {
                              handleRedirectToPages(msg);
                            }}
                          >
                            <Text className="chat-url-link">
                              {" "}
                              {getRedirectUrl(msg?.redirectUrl)}
                            </Text>
                          </div>
                        )}

                        {msg?.role === "bot" && (
                          <>
                            {/* Hint  */}
                            {msg?.hint && (
                              <div className="chat-hint-container">
                                <Text
                                  type="secondary"
                                  className="hint-text-style"
                                >
                                  Hint: {msg?.hint}
                                </Text>
                              </div>
                            )}

                            {/* Suggestions ALWAYS AT BOTTOM */}
                            {msg?.suggestions?.length > 0 && (
                              <div className="chat-suggestions">
                                {msg?.suggestions?.map((item, idx) => (
                                  <div
                                    key={idx}
                                    className="user-options"
                                    onClick={() => handleFetchInfo(item)}
                                  >
                                    {item}
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                    {(isChatLoading || isLoading) && (
                      <div className="ai-guide-content-load typing-indicator-load">
                        Generating response
                      </div>
                    )}
                    <div ref={messagesEndRef} />
                  </div>
                </div>
                <div style={{ padding: "20px" }}>
                  {showUserHelpText && (
                    <div className="user-help-text-div">
                      <Text className="user-help-text">
                        {" "}
                        Your information helps us reach out with relevant AMP
                        services and assistance. We respect your privacy.
                      </Text>
                      <CrossIcon
                        className="user-help-cross"
                        onClick={() => {
                          setShowUserHelpText(false);
                        }}
                      />
                    </div>
                  )}
                  <Divider style={{ marginBottom: "24px", marginTop: "0px" }} />
                  <Input
                    className="chatbot-input"
                    placeholder="Ask Addy.."
                    value={userQuery}
                    onChange={(event) => setUserQuery(event.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !(isChatLoading || isLoading)) {
                        setUserQuery(e.target.value);
                        sendQuestionToAI();
                      }
                    }}
                    suffix={
                      <span>
                        <SendIcon
                          className={`chatSendIcon`}
                          onClick={() => {
                            if (!(isChatLoading || isLoading)) {
                              sendQuestionToAI();
                            }
                          }}
                        />
                      </span>
                    }
                  />
                  <Row className="addy-may-ocassional-row">
                    <Text className="user-help-text">
                      Addy may occasionally provide inaccurate suggestions.
                    </Text>
                  </Row>
                </div>
              </div>
              <Row>
                <CrossIcon
                  className="chat-popover-icon"
                  defaultColor="#121212"
                  onClick={handleChatIcon}
                  style={{ marginTop: "20px" }}
                />
              </Row>
            </div>
          )}
        </div>
      </>
      <Modal
        open={RFP}
        onCancel={handleCancel}
        footer={null}
        centered
        maskClosable={false}
        width="78.438rem"
        height="85%"
        className="submit-rfp-modal-view"
      >
        <RFPModal
          setRFP={setRFP}
          form={form}
          selectedTransferProducts={selectedTransferProducts}
          setSelectedTransferProducts={setSelectedTransferProducts}
        />
      </Modal>
    </>
  );
};

export default Chatbot;
